// Archivo generado por scripts/extract-v46-catalog.mjs. No editar a mano.

export const V46_CATALOG_SOURCE = {
  "source": "_codex_audit/extracted_v46/index.html",
  "version": "4.6-ladrillos-oficial",
  "indexSha256": "E9B2F14B5549192008C80638013CFFF4860D50E82FEC64E667CEF182DAC4ED61"
} as const;

export const PATTERN_CATEGORIES = [
  {
    "id": "madera",
    "name": "Maderas"
  },
  {
    "id": "marmol",
    "name": "Mármol"
  },
  {
    "id": "cuero",
    "name": "Cuero"
  },
  {
    "id": "fibra_carbono",
    "name": "Fibra carbono"
  },
  {
    "id": "fibras_texturas",
    "name": "Fibras y texturas"
  },
  {
    "id": "papeles_naturales",
    "name": "Papeles naturales"
  },
  {
    "id": "metalizados",
    "name": "Metalizados simulados"
  },
  {
    "id": "degrade_premium",
    "name": "Degradés premium"
  },
  {
    "id": "colores_vivos",
    "name": "Colores vivos plenos"
  },
  {
    "id": "colores_mate",
    "name": "Colores mate"
  },
  {
    "id": "fondos_oscuros",
    "name": "Fondos oscuros premium"
  },
  {
    "id": "fondos_claros",
    "name": "Fondos claros premium"
  },
  {
    "id": "texturas_gastronomicas",
    "name": "Texturas gastronómicas"
  },
  {
    "id": "eventos",
    "name": "Estacionales / eventos"
  },
  {
    "id": "infantil_regalo",
    "name": "Infantil / regalo"
  },
  {
    "id": "premium_sobrio",
    "name": "Premium sobrios"
  },
  {
    "id": "ladrillos",
    "name": "Ladrillos"
  }
] as const;

export type PatternCategoryId = (typeof PATTERN_CATEGORIES)[number]['id'];

export interface CatalogPattern {
  readonly id: string;
  readonly name: string;
  readonly categoryId: PatternCategoryId;
  readonly type: 'image';
  readonly assetPath: string;
  readonly sourceUrl: string;
  readonly mimeType: 'image/jpeg';
  readonly sizeBytes: number;
  readonly sha256: string;
}

export const CATALOG_PATTERNS = [
  {
    "id": "madera_01",
    "name": "Madera 01",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_01.jpg",
    "sourceUrl": "patrones/madera/madera_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 324967,
    "sha256": "6096A1E3DA5B0E1196B8B51B4DDF8EEF35FAA7FEF20A6E134D4169731838253A"
  },
  {
    "id": "madera_02",
    "name": "Madera 02",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_02.jpg",
    "sourceUrl": "patrones/madera/madera_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 319106,
    "sha256": "E137F690D07DC601AE840DC7AF908BFE5BB7899B4FB5AACA1E11E63CE60540C7"
  },
  {
    "id": "madera_03",
    "name": "Madera 03",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_03.jpg",
    "sourceUrl": "patrones/madera/madera_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 682881,
    "sha256": "81F4A7B1A7FDCA8FEE562A103C9C3275E0727514EA677F52C231F4D2B334C833"
  },
  {
    "id": "madera_04",
    "name": "Madera 04",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_04.jpg",
    "sourceUrl": "patrones/madera/madera_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 306967,
    "sha256": "FBF7B6B697E67EDF1E03F7C552FAD33BF8AA7B8616CDDE21AFE840A4EC988B4D"
  },
  {
    "id": "madera_05",
    "name": "Madera 05",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_05.jpg",
    "sourceUrl": "patrones/madera/madera_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 283481,
    "sha256": "A93D8D3E99AE953928476598D3F23563CCA2B134068FB073463FA2664F01CB07"
  },
  {
    "id": "madera_06",
    "name": "Madera 06",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_06.jpg",
    "sourceUrl": "patrones/madera/madera_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 381667,
    "sha256": "1675F5561BBE749509AEF4C007B7CC0DDAC3E67980AEB3F22E1FB9F219BBF9E7"
  },
  {
    "id": "madera_07",
    "name": "Madera 07",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_07.jpg",
    "sourceUrl": "patrones/madera/madera_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 467308,
    "sha256": "7C764E586182EF10FA51F264E926CBE9224E5BC8B2A51B1BEC3E3C8E2C4EE93C"
  },
  {
    "id": "madera_08",
    "name": "Madera 08",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_08.jpg",
    "sourceUrl": "patrones/madera/madera_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 450645,
    "sha256": "7F2488B903034B5FF562DF1A574194F841B06F8C96A5786D348C570A9F565044"
  },
  {
    "id": "madera_09",
    "name": "Madera 09",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_09.jpg",
    "sourceUrl": "patrones/madera/madera_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 425491,
    "sha256": "693A558A718A4087C8C3367D28550208C5982584941646BC2895358A223BD564"
  },
  {
    "id": "madera_10",
    "name": "Madera 10",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_10.jpg",
    "sourceUrl": "patrones/madera/madera_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 329538,
    "sha256": "F6EA726FDF287FD7142527BA757D25EAF4F18A655D49D1A7FCA4B8D72B65602B"
  },
  {
    "id": "madera_11",
    "name": "Madera 11",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_11.jpg",
    "sourceUrl": "patrones/madera/madera_11.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 437104,
    "sha256": "92ACCB657889357D35E03EA3AD12986C81E9FC40166E7EE40F51C3B0B736D86F"
  },
  {
    "id": "madera_12",
    "name": "Madera 12",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_12.jpg",
    "sourceUrl": "patrones/madera/madera_12.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 257252,
    "sha256": "410BC49EC1C1C85A602BD5D07927537F48645E67956595FDB6FECC2A66EACFBE"
  },
  {
    "id": "madera_13",
    "name": "Madera 13",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_13.jpg",
    "sourceUrl": "patrones/madera/madera_13.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 328624,
    "sha256": "352934019A01B3D598E4D5389430765E55A5849C2AF2A441DD60667E047871D9"
  },
  {
    "id": "madera_14",
    "name": "Madera 14",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_14.jpg",
    "sourceUrl": "patrones/madera/madera_14.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 343224,
    "sha256": "59955ABEE659DBBAA838A07E226B6D62E44665F77892BFC4B25502CEA6897130"
  },
  {
    "id": "madera_15",
    "name": "Madera 15",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_15.jpg",
    "sourceUrl": "patrones/madera/madera_15.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 267692,
    "sha256": "634813B9F3B99376B042DD36D1C0E14EB0AA0CE65740FF7E70DA33B5E9B37437"
  },
  {
    "id": "madera_16",
    "name": "Madera 16",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_16.jpg",
    "sourceUrl": "patrones/madera/madera_16.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 330813,
    "sha256": "7E5138E91349E2936BCF5882D82AC5D5CC45D2693B40A9A9CE5F4C60EB8BD5CF"
  },
  {
    "id": "madera_17",
    "name": "Madera 17",
    "categoryId": "madera",
    "type": "image",
    "assetPath": "patrones/madera/madera_17.jpg",
    "sourceUrl": "patrones/madera/madera_17.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 261418,
    "sha256": "4A68AC49D093B72A9FD8865CB3D5FD383DF941DB4BA5CAE28310CB3A44FBFDAB"
  },
  {
    "id": "marmol_01",
    "name": "Mármol 01",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_01.jpg",
    "sourceUrl": "patrones/marmol/marmol_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 165307,
    "sha256": "53F955397A85325EFE36CE3E252F2ECF65F0AEEC469362CE0D18B7F200BA78E9"
  },
  {
    "id": "marmol_02",
    "name": "Mármol 02",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_02.jpg",
    "sourceUrl": "patrones/marmol/marmol_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 423987,
    "sha256": "C2D57B13BC70111BC5A433E89424B6717D46857368296CF73266AFDD670EE038"
  },
  {
    "id": "marmol_03",
    "name": "Mármol 03",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_03.jpg",
    "sourceUrl": "patrones/marmol/marmol_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 421303,
    "sha256": "D90B77FD0247B503EEC1DC902D629CD2B107D5DB36BF12C36671F5900F358F38"
  },
  {
    "id": "marmol_04",
    "name": "Mármol 04",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_04.jpg",
    "sourceUrl": "patrones/marmol/marmol_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 119002,
    "sha256": "69205AC31C4CA0A55AA22B8F0F4A54E7A7CF82A4A5E304196EC95C6C7FCC88EC"
  },
  {
    "id": "marmol_05",
    "name": "Mármol 05",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_05.jpg",
    "sourceUrl": "patrones/marmol/marmol_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 244757,
    "sha256": "559F754CC3BA2DF9892CA44339FB575636486F02DF37F1CBDAEF4AA3EF1052C8"
  },
  {
    "id": "marmol_06",
    "name": "Mármol 06",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_06.jpg",
    "sourceUrl": "patrones/marmol/marmol_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 472247,
    "sha256": "73FA9D61C34947C9CA45EBE1DC999C89C84CD75236535432B63C1F27C6E7F0F6"
  },
  {
    "id": "marmol_07",
    "name": "Mármol 07",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_07.jpg",
    "sourceUrl": "patrones/marmol/marmol_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 485184,
    "sha256": "66447B19A00C4B0E0E72C48419AEE53B04541D22F8A50A1749B34D6ABD21E2FB"
  },
  {
    "id": "marmol_08",
    "name": "Mármol 08",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_08.jpg",
    "sourceUrl": "patrones/marmol/marmol_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 548296,
    "sha256": "31F5C68E9AB0412B5CFC45A0AE0F651797C9CEEBE2D8BABBBBEF5E175E39978C"
  },
  {
    "id": "marmol_09",
    "name": "Mármol 09",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_09.jpg",
    "sourceUrl": "patrones/marmol/marmol_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 229896,
    "sha256": "1C404783947252CFA3B35DDAF87DB08F4DF822FED7C2FD01A7F4FE9D12FD60AC"
  },
  {
    "id": "marmol_10",
    "name": "Mármol 10",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_10.jpg",
    "sourceUrl": "patrones/marmol/marmol_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 227236,
    "sha256": "9A3213FC74BDE53A635C857BCD052AEDEC1B947CD4F005FAF320A5BB92DB82E6"
  },
  {
    "id": "marmol_11",
    "name": "Mármol 11",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_11.jpg",
    "sourceUrl": "patrones/marmol/marmol_11.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 264399,
    "sha256": "32A72E861DC2203552BE9FCC1534497442FE1CFCEE653D56CB31D91273F8DD9E"
  },
  {
    "id": "marmol_12",
    "name": "Mármol 12",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_12.jpg",
    "sourceUrl": "patrones/marmol/marmol_12.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 374714,
    "sha256": "56BAFFD135AA7F1224B0A22C0721E5A972BD6D75F0DE80227D85A145ECBAC095"
  },
  {
    "id": "marmol_13",
    "name": "Mármol 13",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_13.jpg",
    "sourceUrl": "patrones/marmol/marmol_13.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 128957,
    "sha256": "CDD252ADEAAB3C0CF2ABC1695EF1ED374E1446C9E3DDB24AAEB227BAED104153"
  },
  {
    "id": "marmol_14",
    "name": "Mármol 14",
    "categoryId": "marmol",
    "type": "image",
    "assetPath": "patrones/marmol/marmol_14.jpg",
    "sourceUrl": "patrones/marmol/marmol_14.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 497329,
    "sha256": "19C77835498020D22C0F2010C5F094341BE5D5E07282B92E5FAE7B2CC67128C0"
  },
  {
    "id": "cuero_01",
    "name": "Cuero 01",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_01.jpg",
    "sourceUrl": "patrones/cuero/cuero_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 464136,
    "sha256": "DE36E6363361C84122B14DD4671C7CB9B3853C30E069503E467AF4C9D7199E17"
  },
  {
    "id": "cuero_02",
    "name": "Cuero 02",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_02.jpg",
    "sourceUrl": "patrones/cuero/cuero_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 615971,
    "sha256": "B3F20937906BB6F6651D1E0B50EDB394762A8E340C5887C3A3153E01E3F1E31F"
  },
  {
    "id": "cuero_03",
    "name": "Cuero 03",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_03.jpg",
    "sourceUrl": "patrones/cuero/cuero_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 535098,
    "sha256": "7F71B60C3BCE0CF036661BE76E82698C2818C916F3F204ACD3DEEBEDCE7548BA"
  },
  {
    "id": "cuero_04",
    "name": "Cuero 04",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_04.jpg",
    "sourceUrl": "patrones/cuero/cuero_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 541310,
    "sha256": "FDC0DD523EEEDDAF7077F70413F864F4255C3EA882E9B138E034A7A0499105D1"
  },
  {
    "id": "cuero_05",
    "name": "Cuero 05",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_05.jpg",
    "sourceUrl": "patrones/cuero/cuero_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 558844,
    "sha256": "D46DE3C3B39CCE8743ED873159C1C4B80805670EF765350617F94E3A6DA90D70"
  },
  {
    "id": "cuero_06",
    "name": "Cuero 06",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_06.jpg",
    "sourceUrl": "patrones/cuero/cuero_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 515477,
    "sha256": "21C1B9586BCEC308033D32A7B2BA22711A01A9C279B7FF95F1E44031BC663FEA"
  },
  {
    "id": "cuero_07",
    "name": "Cuero 07",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_07.jpg",
    "sourceUrl": "patrones/cuero/cuero_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 514136,
    "sha256": "4F890421A00FDE0CDF86D85458C828351F5B3DF16785313A925667D075412F6D"
  },
  {
    "id": "cuero_08",
    "name": "Cuero 08",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_08.jpg",
    "sourceUrl": "patrones/cuero/cuero_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 577582,
    "sha256": "68274D57D0074810A3736246F2A8217D16F036A40D1486810473DEE523523F74"
  },
  {
    "id": "cuero_09",
    "name": "Cuero 09",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_09.jpg",
    "sourceUrl": "patrones/cuero/cuero_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 601576,
    "sha256": "E3CA7F42FBF5EC9BAC4F34F35FC8D87DACAC094BCD8426F61A22DBAFE943C5D7"
  },
  {
    "id": "cuero_10",
    "name": "Cuero 10",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_10.jpg",
    "sourceUrl": "patrones/cuero/cuero_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 626972,
    "sha256": "86E53A22CFFA1468FD57BA3E9ACED2BE454BE262EF9B4C81CEDB0E4DC9B9A425"
  },
  {
    "id": "cuero_11",
    "name": "Cuero 11",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_11.jpg",
    "sourceUrl": "patrones/cuero/cuero_11.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 1492981,
    "sha256": "7A910094721688DD99FF9A379624EAA9C151BA53ADF3BA06DD6F11BE50E4EB78"
  },
  {
    "id": "cuero_12",
    "name": "Cuero 12",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_12.jpg",
    "sourceUrl": "patrones/cuero/cuero_12.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 539219,
    "sha256": "291B241C041CDDF7B76598B271510AD6B0C5A03640968786A642AB89E4623D8D"
  },
  {
    "id": "cuero_13",
    "name": "Cuero 13",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_13.jpg",
    "sourceUrl": "patrones/cuero/cuero_13.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 495091,
    "sha256": "67F4AD57A35832A4E52ADB4ECDA3C505FAC570FD730942E502B8CF902E750984"
  },
  {
    "id": "cuero_14",
    "name": "Cuero 14",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_14.jpg",
    "sourceUrl": "patrones/cuero/cuero_14.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 461898,
    "sha256": "78CBD4FDD2CBD64455716C3FB34DFDEE16271E88752A247F4081FFA0BB8E0E7E"
  },
  {
    "id": "cuero_15",
    "name": "Cuero 15",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_15.jpg",
    "sourceUrl": "patrones/cuero/cuero_15.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 1290732,
    "sha256": "1E9EBE6AB8204286ECBDD317F021660C1256173BD57AFF893BBCC95E5AD0551F"
  },
  {
    "id": "cuero_16",
    "name": "Cuero 16",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_16.jpg",
    "sourceUrl": "patrones/cuero/cuero_16.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 1211322,
    "sha256": "99A0D750C5621322CC0305E6D06617883568ABEB3F599C849FEEE9BBAB13693D"
  },
  {
    "id": "cuero_17",
    "name": "Cuero 17",
    "categoryId": "cuero",
    "type": "image",
    "assetPath": "patrones/cuero/cuero_17.jpg",
    "sourceUrl": "patrones/cuero/cuero_17.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 1216393,
    "sha256": "E5F2EC82FFD726E0B074E1C0E6F0F06B7992FF62FA42529E1C7C655B9FBC558E"
  },
  {
    "id": "fibra_carbono_01",
    "name": "Fibra carbono 01",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_01.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 309828,
    "sha256": "89ADFE7E7AFE7C4B85A1B05C228D13CE367AE1E5DAC68777F0B95B2C51DCA86D"
  },
  {
    "id": "fibra_carbono_02",
    "name": "Fibra carbono 02",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_02.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 277518,
    "sha256": "D46CC1A1BE5143BEA0F049978146ACF0EC9F4BB0A58F7AEC9B7D982889B9A906"
  },
  {
    "id": "fibra_carbono_03",
    "name": "Fibra carbono 03",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_03.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 348921,
    "sha256": "6297002658444F60A9DB12C58EE6A92B3C8009E9010AC96E833D16D289FB6601"
  },
  {
    "id": "fibra_carbono_04",
    "name": "Fibra carbono 04",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_04.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 345449,
    "sha256": "3A8E92BDD3255A7D73804F2CBA7B7A55B54B2FDCF7849E573DC250E6A1DAE595"
  },
  {
    "id": "fibra_carbono_05",
    "name": "Fibra carbono 05",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_05.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 245860,
    "sha256": "10AFE0F7AD5776EB41A1C8D6C3A3377B81A756CB55330F4E81F235F0778658B1"
  },
  {
    "id": "fibra_carbono_06",
    "name": "Fibra carbono 06",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_06.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 231348,
    "sha256": "F8813BAEA17BC9BA97419A8C889C7E3FD3B0010149CE34467F93F5C11FE9665A"
  },
  {
    "id": "fibra_carbono_07",
    "name": "Fibra carbono 07",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_07.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 265285,
    "sha256": "5B502496D0824ED260569F2A2F2B53A16DD99A27D6DDE348CAA413D8D96354B1"
  },
  {
    "id": "fibra_carbono_08",
    "name": "Fibra carbono 08",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_08.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 251786,
    "sha256": "348B4FBE381B029CECAF819A26224D823BF5B446B351A4D5DEA62A5AA2F37D79"
  },
  {
    "id": "fibra_carbono_09",
    "name": "Fibra carbono 09",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_09.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 251406,
    "sha256": "4B88D347BB2FBF5AC901CA879A49ABE569F43376CE16328D169C3B54424ABADF"
  },
  {
    "id": "fibra_carbono_10",
    "name": "Fibra carbono 10",
    "categoryId": "fibra_carbono",
    "type": "image",
    "assetPath": "patrones/fibra_carbono/fibra_carbono_10.jpg",
    "sourceUrl": "patrones/fibra_carbono/fibra_carbono_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 271919,
    "sha256": "943B8ABD90799BA63A09AE426F5B4ECDE31CBD4A55D70EB501223CD4C1E370BF"
  },
  {
    "id": "fibras_texturas_01",
    "name": "Fibra/textura 01",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_01.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 353218,
    "sha256": "8E33A7D5A230E4E3C3B622CE01572953352B811C8682AE12FB88D0A3B86F5EE1"
  },
  {
    "id": "fibras_texturas_02",
    "name": "Fibra/textura 02",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_02.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 434840,
    "sha256": "CF5288BE4554AA9CE065E49DD7A537CDB460A9A5359913C3FD775CE101A6E861"
  },
  {
    "id": "fibras_texturas_03",
    "name": "Fibra/textura 03",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_03.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 552825,
    "sha256": "815B023BF69172ADE983B5A2A27C344DBB1F318AAA2531ECF7F02AADA6F0E0AC"
  },
  {
    "id": "fibras_texturas_04",
    "name": "Fibra/textura 04",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_04.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 276596,
    "sha256": "1C7611A5F639DCE13C8633AC78A3634BA38B01C6BB85109A26B9DE4158C0AE6E"
  },
  {
    "id": "fibras_texturas_05",
    "name": "Fibra/textura 05",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_05.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 236214,
    "sha256": "E9502FE30E310FE7221EFA3FF2B05BD35218963BF4839E7BF00A7CD08A255051"
  },
  {
    "id": "fibras_texturas_06",
    "name": "Fibra/textura 06",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_06.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 540756,
    "sha256": "2C6129B2F76971BE89CCDA2639F9C4C68257286AC193E13B1191DB8FFC526C7D"
  },
  {
    "id": "fibras_texturas_07",
    "name": "Fibra/textura 07",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_07.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 361758,
    "sha256": "66C59E35B33BA7ADC8154BBABD1C4376C8AEAFEA46B2FA73319B1BDD215B3D47"
  },
  {
    "id": "fibras_texturas_08",
    "name": "Fibra/textura 08",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_08.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 566439,
    "sha256": "33FA2828487BAB45730D428DDFD5E1493BBCE7BB1437FFCB28131EF3428C2D34"
  },
  {
    "id": "fibras_texturas_09",
    "name": "Fibra/textura 09",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_09.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 586680,
    "sha256": "837C53001F263F114C216EEFA74E7299E40BEAED77B7E99753F6A85B66D15B92"
  },
  {
    "id": "fibras_texturas_10",
    "name": "Fibra/textura 10",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_10.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 473546,
    "sha256": "36E4AABD572149769713340F6DD8CE88EA06ABFE32AC1A16451194BE838990FB"
  },
  {
    "id": "fibras_texturas_11",
    "name": "Fibra/textura 11",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_11.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_11.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 330385,
    "sha256": "5B492B42D3C3CF46CC77E93776C3EF3EF5B6B83C09BF8281FB6DF4AB50135A4F"
  },
  {
    "id": "fibras_texturas_12",
    "name": "Fibra/textura 12",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_12.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_12.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 469918,
    "sha256": "873CFE25D46A3DA6B01D2EE9EC9472735ED78A458E082944FF496026657D8953"
  },
  {
    "id": "fibras_texturas_13",
    "name": "Fibra/textura 13",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_13.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_13.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 367318,
    "sha256": "874F70F73D04C6B88470B3533C8118AF83D2D8B12CB140EFBD00ADB8AADB7198"
  },
  {
    "id": "fibras_texturas_14",
    "name": "Fibra/textura 14",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_14.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_14.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 399765,
    "sha256": "CA5C0479345B2D93385041B02814617E5CC311DDC52D64CAA27F3ACB2D2A6004"
  },
  {
    "id": "fibras_texturas_15",
    "name": "Fibra/textura 15",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_15.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_15.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 339109,
    "sha256": "E3908D1916426167243B3E9FC2D9C4A72ECCA2751362486C3C1221BA80F41798"
  },
  {
    "id": "fibras_texturas_16",
    "name": "Fibra/textura 16",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_16.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_16.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 611611,
    "sha256": "523DA61085727A5F4EF2781E9642833C93CFE889C74497E00E02BA194BD99772"
  },
  {
    "id": "fibras_texturas_17",
    "name": "Fibra/textura 17",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_17.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_17.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 514849,
    "sha256": "CECDCC83F6D695E0BA8A1CA1E1F209E74A9B8338D98F457B7AADBDF456D6BE6E"
  },
  {
    "id": "fibras_texturas_18",
    "name": "Fibra/textura 18",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_18.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_18.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 782007,
    "sha256": "7B83CA168D4763E9A12AF9D86264B510A576901CDC287BD2BB2B08B12B4CF739"
  },
  {
    "id": "fibras_texturas_19",
    "name": "Fibra/textura 19",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_19.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_19.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 577701,
    "sha256": "5F1E1283C925E536999A72294903D40B19C6EEA3F77F602691DF5196F24AA5F5"
  },
  {
    "id": "fibras_texturas_20",
    "name": "Fibra/textura 20",
    "categoryId": "fibras_texturas",
    "type": "image",
    "assetPath": "patrones/fibras_texturas/fibras_texturas_20.jpg",
    "sourceUrl": "patrones/fibras_texturas/fibras_texturas_20.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 529802,
    "sha256": "A32ACA27435D85C3814E2065F9FD176BAD1B247080BE45986BC0C97E65F99D6C"
  },
  {
    "id": "papeles_naturales_01",
    "name": "Papel natural 01",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_01.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 480142,
    "sha256": "4C88FEDEF8BA847E273921B9E5CCAEA5C35AE2A25AF1FA9CE47DD6BB1510854A"
  },
  {
    "id": "papeles_naturales_02",
    "name": "Papel natural 02",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_02.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 352715,
    "sha256": "B9D8D890E197F07548DD5F9F4FAAE337AE6BDF3C652528E9B7A810123C4A397E"
  },
  {
    "id": "papeles_naturales_03",
    "name": "Papel natural 03",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_03.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 286980,
    "sha256": "1A91F4B9E06C59F76D6C1487936CFA73E3F440B86472E55749BDAC09DD5C4B45"
  },
  {
    "id": "papeles_naturales_04",
    "name": "Papel natural 04",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_04.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 330765,
    "sha256": "71B89DC90EEDB82E8D3FEFBDD22ED6B073D9FC2A758100235E5AE55A5FF6DFDD"
  },
  {
    "id": "papeles_naturales_05",
    "name": "Papel natural 05",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_05.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 323535,
    "sha256": "1555E3DF2751C088694E1C18E026007C780C3E6F3EE18152159AEA0BD98E5355"
  },
  {
    "id": "papeles_naturales_06",
    "name": "Papel natural 06",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_06.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 342528,
    "sha256": "57F9789B3526E80634B9BE397C4B9BE4C28A892CDAF5D307D15D30F691609DED"
  },
  {
    "id": "papeles_naturales_07",
    "name": "Papel natural 07",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_07.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 338722,
    "sha256": "8222214B25868FF4AD1E0106B4A32ECEA457201CE9A4D2AC8BF8806DC826BF25"
  },
  {
    "id": "papeles_naturales_08",
    "name": "Papel natural 08",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_08.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 482223,
    "sha256": "5895237A345EEA8F7C4C656C6D33CB9A2D3A56616E1DED338C080416A5C13E52"
  },
  {
    "id": "papeles_naturales_09",
    "name": "Papel natural 09",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_09.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 390888,
    "sha256": "3D2EC11DE270E97FF32D90E8A1E483AAAFD5193058D55A7D09023AE945402051"
  },
  {
    "id": "papeles_naturales_10",
    "name": "Papel natural 10",
    "categoryId": "papeles_naturales",
    "type": "image",
    "assetPath": "patrones/papeles_naturales/papeles_naturales_10.jpg",
    "sourceUrl": "patrones/papeles_naturales/papeles_naturales_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 402996,
    "sha256": "5969091B9C95C291B23E6CA4BB5598505878E845275B829793722A23B2805BB1"
  },
  {
    "id": "metalizados_01",
    "name": "Metalizado símil 01",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_01.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 310277,
    "sha256": "D9893F1E2EBFDE1F423B3F4AAB67986A41005602D6E5CE68711FE3DCE6F320CB"
  },
  {
    "id": "metalizados_02",
    "name": "Metalizado símil 02",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_02.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 519441,
    "sha256": "9F60A79BFFD4ACB33BF20D6B4850B9A99F3D76EAA05BF3C5A65762E3495B1039"
  },
  {
    "id": "metalizados_03",
    "name": "Metalizado símil 03",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_03.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 407140,
    "sha256": "7BD50F2147B942BFF1EF463677F567C6925F34C077B9F496B4665D06BADC0E50"
  },
  {
    "id": "metalizados_04",
    "name": "Metalizado símil 04",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_04.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 363322,
    "sha256": "2BB3940B179A0751A9E554B372B42732B292E31E1F9E0F6EA82D147F071EA280"
  },
  {
    "id": "metalizados_05",
    "name": "Metalizado símil 05",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_05.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 254645,
    "sha256": "83C161907FFB3668DB468433643529074FAAF5BDDF34827E9697702307E80BE6"
  },
  {
    "id": "metalizados_06",
    "name": "Metalizado símil 06",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_06.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 343729,
    "sha256": "975695218CDB3AC54C5C07158C7C46FB3D603C06C3D4827C56E2E88A0C0C1716"
  },
  {
    "id": "metalizados_07",
    "name": "Metalizado símil 07",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_07.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 253877,
    "sha256": "DA3A7B41635E29695D158679833B4F2C4ACA8771F153863038F77D8BD3F66C07"
  },
  {
    "id": "metalizados_08",
    "name": "Metalizado símil 08",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_08.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 292123,
    "sha256": "1D69E81067EDF6879824FC55CF1BB68B4095FBDA3F3A4515C9E603D498D1B969"
  },
  {
    "id": "metalizados_09",
    "name": "Metalizado símil 09",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_09.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 440680,
    "sha256": "85FB57604C23DCFFA47A53F1E2020E727C34A066D8106ECE14FBBEFF99124A8A"
  },
  {
    "id": "metalizados_10",
    "name": "Metalizado símil 10",
    "categoryId": "metalizados",
    "type": "image",
    "assetPath": "patrones/metalizados/metalizados_10.jpg",
    "sourceUrl": "patrones/metalizados/metalizados_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 292125,
    "sha256": "CF34416A0512B0EBF350541D7A93F7DFA705AAE43A31CC83734E7D5287EBD752"
  },
  {
    "id": "degrade_premium_01",
    "name": "Degradé premium 01",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_01.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 181277,
    "sha256": "7F5082DBC0AEBF9742F6C924A510E112E76E06E527A9DFAC52727F28E37992C6"
  },
  {
    "id": "degrade_premium_02",
    "name": "Degradé premium 02",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_02.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 202199,
    "sha256": "85797EEF86B37996F8048C03BF6C0140F682D73792F33CA72E9A8759470FB820"
  },
  {
    "id": "degrade_premium_03",
    "name": "Degradé premium 03",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_03.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 352959,
    "sha256": "2336EEEE3F8F1BBC0EB53AC1B5431EED842899C7C139C55851729884DD007EC6"
  },
  {
    "id": "degrade_premium_04",
    "name": "Degradé premium 04",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_04.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 177891,
    "sha256": "B869D4629201D0178BEC1471699DA11CFECFCC425D3DB61991A24672C6D6F20C"
  },
  {
    "id": "degrade_premium_05",
    "name": "Degradé premium 05",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_05.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 142278,
    "sha256": "217EB72539487C448EC76084924F3573B94C72E08DE538FD5A988F6DDE0560B8"
  },
  {
    "id": "degrade_premium_06",
    "name": "Degradé premium 06",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_06.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 239508,
    "sha256": "71A4FF86BFBFE129BF798BF806B21403D51D821CA58CF02CBF83F4689CC395F7"
  },
  {
    "id": "degrade_premium_07",
    "name": "Degradé premium 07",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_07.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 235505,
    "sha256": "7345308F18A65869A0A68A3E011505D4C3553F2EB041C1BAAC6DC0FF695C6434"
  },
  {
    "id": "degrade_premium_08",
    "name": "Degradé premium 08",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_08.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 188844,
    "sha256": "D54C553D675DF31FCBF923D8B8DF7AA5D74300E5745AFC1784A62D8748B6BBCB"
  },
  {
    "id": "degrade_premium_09",
    "name": "Degradé premium 09",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_09.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 300225,
    "sha256": "DE8E8F445E3E7899EAB2437D009607C7602522D0E2650492A6B0C47DA4F3829A"
  },
  {
    "id": "degrade_premium_10",
    "name": "Degradé premium 10",
    "categoryId": "degrade_premium",
    "type": "image",
    "assetPath": "patrones/degrade_premium/degrade_premium_10.jpg",
    "sourceUrl": "patrones/degrade_premium/degrade_premium_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 239301,
    "sha256": "AB54888CFC1989E1A0DBC64813EBA32D2B8C91A1B8B808373C0E8E6BA0ECF963"
  },
  {
    "id": "colores_vivos_01",
    "name": "Color vivo pleno 01",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_01.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 32882,
    "sha256": "534E713F9DA21FF64AE612BD7DC3EFA2583077863E44041461B905059EAA5B8A"
  },
  {
    "id": "colores_vivos_02",
    "name": "Color vivo pleno 02",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_02.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 30407,
    "sha256": "3EC01120B2CEAD4AB4D45679EB5BAF022FEF34943E257FFF6B5DD682B867B10D"
  },
  {
    "id": "colores_vivos_03",
    "name": "Color vivo pleno 03",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_03.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 31193,
    "sha256": "50A3C4CD39FBC9F149FBAA5B94468DBD35B0ED9D72EBBCF46BCA1082A9CF56FD"
  },
  {
    "id": "colores_vivos_04",
    "name": "Color vivo pleno 04",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_04.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 34682,
    "sha256": "95B645BC3C64F6C6C5C8C4A647CEBF01820CE6102DF58348CABC37D19193B950"
  },
  {
    "id": "colores_vivos_05",
    "name": "Color vivo pleno 05",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_05.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 31751,
    "sha256": "2AFA4E73823656F607206C3F49E0F48E063586760B7681BA917C73395E78C6D4"
  },
  {
    "id": "colores_vivos_06",
    "name": "Color vivo pleno 06",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_06.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 30333,
    "sha256": "EBE8DE449A47FC400EB6C241723F1A3EF230F0A99E54B0BEAFF0EAA2E07738CE"
  },
  {
    "id": "colores_vivos_07",
    "name": "Color vivo pleno 07",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_07.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 33621,
    "sha256": "B4FDF26184DA554C0A8840302CBABBD6B2B8EA9F07621CD91CDD52D5795A8F0B"
  },
  {
    "id": "colores_vivos_08",
    "name": "Color vivo pleno 08",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_08.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 33146,
    "sha256": "71169329C5948764836ABA26A989C99CF566292F8A67C2E70B3AA2D27AEF040E"
  },
  {
    "id": "colores_vivos_09",
    "name": "Color vivo pleno 09",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_09.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 32814,
    "sha256": "53A2537CA3C04653EDE8707F5992B6D317B1DAAE88DC39D555C085A3CCBA5946"
  },
  {
    "id": "colores_vivos_10",
    "name": "Color vivo pleno 10",
    "categoryId": "colores_vivos",
    "type": "image",
    "assetPath": "patrones/colores_vivos/colores_vivos_10.jpg",
    "sourceUrl": "patrones/colores_vivos/colores_vivos_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 15740,
    "sha256": "CFE2809EE750EA221FD5D412DB35F30B6881EA5AFE23EF3C855AC1E5915F47EC"
  },
  {
    "id": "colores_mate_01",
    "name": "Color mate 01",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_01.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 29809,
    "sha256": "62FF328CD3DCEBE34E4512D7D7FB649378582C240B8277F9A960DCE87348ACDF"
  },
  {
    "id": "colores_mate_02",
    "name": "Color mate 02",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_02.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 29869,
    "sha256": "FC6845A04905B48A309C2D908C32C88BDD58E81B481D037812F58ADD1F1CDD84"
  },
  {
    "id": "colores_mate_03",
    "name": "Color mate 03",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_03.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 29844,
    "sha256": "E7A97B502FA8674B7E9D49588845F7AA0561DBD0CB53E0327D4CD9583E823CD6"
  },
  {
    "id": "colores_mate_04",
    "name": "Color mate 04",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_04.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 29961,
    "sha256": "8DD7F99AECA54BF0500A127C60E29571A1D3648ADBBEAA2BCFE19AFBE48985C2"
  },
  {
    "id": "colores_mate_05",
    "name": "Color mate 05",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_05.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 30766,
    "sha256": "E6C30934CA96F16908DC126B3298EF123847DAB9AD567ADC6B4686F1D5A2D847"
  },
  {
    "id": "colores_mate_06",
    "name": "Color mate 06",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_06.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 31295,
    "sha256": "1B48B8882943C7D7DECBC85EF5B05AAF1879CC67A9984728AA7A9682E9CB76E5"
  },
  {
    "id": "colores_mate_07",
    "name": "Color mate 07",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_07.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 30556,
    "sha256": "A8D3DBB17048290A624F4431202F0EF93D2E6B4BA12F6494C1F66C08886613EE"
  },
  {
    "id": "colores_mate_08",
    "name": "Color mate 08",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_08.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 31207,
    "sha256": "6180C57C26278B25561AE9BB667F5A56A8325A55FBDA4FDE3B69EB516E27E376"
  },
  {
    "id": "colores_mate_09",
    "name": "Color mate 09",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_09.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 31375,
    "sha256": "9C4093CE7A9C1B97B82B671FF3D2D70ADBD6F4028F155D495215B3B38C5CCA18"
  },
  {
    "id": "colores_mate_10",
    "name": "Color mate 10",
    "categoryId": "colores_mate",
    "type": "image",
    "assetPath": "patrones/colores_mate/colores_mate_10.jpg",
    "sourceUrl": "patrones/colores_mate/colores_mate_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 32654,
    "sha256": "13BC9C99AE95B571426A96B48E5E32F65AA64ABAF5B68B9BEFB0448F3882DB38"
  },
  {
    "id": "fondos_oscuros_01",
    "name": "Fondo oscuro premium 01",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_01.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 185147,
    "sha256": "F8D65188CCE77173DD3C4D41419A360E8079055C57BCE8AB0F25D302827D48F2"
  },
  {
    "id": "fondos_oscuros_02",
    "name": "Fondo oscuro premium 02",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_02.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 286519,
    "sha256": "3E1A08AC34D2872088B3DB59B3049D8DA36E380FC7B4D3A936069CFE08BE58B7"
  },
  {
    "id": "fondos_oscuros_03",
    "name": "Fondo oscuro premium 03",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_03.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 232802,
    "sha256": "9F6D8FEAE5A74C739AC100D81C1A4C6F4D4082FCB9FA864EF5116AA9B0C7F9F7"
  },
  {
    "id": "fondos_oscuros_04",
    "name": "Fondo oscuro premium 04",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_04.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 222561,
    "sha256": "D0BFF27E4061BCBC2D27B30EAB39149A2AA5786690BC5CA0C23B37C064974D2D"
  },
  {
    "id": "fondos_oscuros_05",
    "name": "Fondo oscuro premium 05",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_05.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 192131,
    "sha256": "D88410F8394D157AD48681664218A926C315FAB1E44819FFBE47A75E70ECDA08"
  },
  {
    "id": "fondos_oscuros_06",
    "name": "Fondo oscuro premium 06",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_06.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 210380,
    "sha256": "1FFEBCDEF725E511961CBCCCBBFFE4615A86F786FCEC93FDA054D59C72E44625"
  },
  {
    "id": "fondos_oscuros_07",
    "name": "Fondo oscuro premium 07",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_07.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 407919,
    "sha256": "39F920C329DE495EE4335842328FA6F8D61EF50969B0594B4D77129521B95364"
  },
  {
    "id": "fondos_oscuros_08",
    "name": "Fondo oscuro premium 08",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_08.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 153835,
    "sha256": "EB1A394AFF520CE57577B5885C12186976E90E4FD29CAA1E57A98AB88E17D758"
  },
  {
    "id": "fondos_oscuros_09",
    "name": "Fondo oscuro premium 09",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_09.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 217785,
    "sha256": "9D93EBC840BB68837E93AEF00EF484075776A7212F72F2944EEA51053C798C3D"
  },
  {
    "id": "fondos_oscuros_10",
    "name": "Fondo oscuro premium 10",
    "categoryId": "fondos_oscuros",
    "type": "image",
    "assetPath": "patrones/fondos_oscuros/fondos_oscuros_10.jpg",
    "sourceUrl": "patrones/fondos_oscuros/fondos_oscuros_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 144495,
    "sha256": "9BB3B7DF1BE42DB477A08B0AC36AFF1FAE3B13AE559C89B01599DC66721D0CB2"
  },
  {
    "id": "fondos_claros_01",
    "name": "Fondo claro premium 01",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_01.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 182044,
    "sha256": "1B0491BB20EDBDC930CB98F128CCB81CF3D7C0892F12D88C282F57C899142988"
  },
  {
    "id": "fondos_claros_02",
    "name": "Fondo claro premium 02",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_02.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 290226,
    "sha256": "82676769BB3D98AFE24F3369F67482D476B9C8BC765CFD63ACA51E4F86656809"
  },
  {
    "id": "fondos_claros_03",
    "name": "Fondo claro premium 03",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_03.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 200365,
    "sha256": "F6C5CE3E8AF64A2E819FB16CBB9FCA30FB796191A4429CB27A352441686FDF13"
  },
  {
    "id": "fondos_claros_04",
    "name": "Fondo claro premium 04",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_04.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 134940,
    "sha256": "40A3095BF48C8A0884E95A5B1B97629F94AA63D270CBC3EF9D488DE20C1AC3FD"
  },
  {
    "id": "fondos_claros_05",
    "name": "Fondo claro premium 05",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_05.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 301995,
    "sha256": "553106C173DCFF8F291A00B737099B5875CE8B8239D2570099E7968E72BD3BB4"
  },
  {
    "id": "fondos_claros_06",
    "name": "Fondo claro premium 06",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_06.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 313683,
    "sha256": "F7343ED1A2AE65B6FDCFD41E65D9632D5C3F47B9A82FA0995E44987C1134787A"
  },
  {
    "id": "fondos_claros_07",
    "name": "Fondo claro premium 07",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_07.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 308654,
    "sha256": "2229D2ED5C65B4658E6BA1AEBF0A748589BB50BD7375165F934558D32049A099"
  },
  {
    "id": "fondos_claros_08",
    "name": "Fondo claro premium 08",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_08.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 289642,
    "sha256": "1D251696D9D3EDD0128EB5B421028E66A97EFC74ADF4BA18A14B2F6A3C5C6B8E"
  },
  {
    "id": "fondos_claros_09",
    "name": "Fondo claro premium 09",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_09.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 293666,
    "sha256": "29090337AD94ABF847ACBA7E70D58742A84AF002160E06C5605361504E1063CF"
  },
  {
    "id": "fondos_claros_10",
    "name": "Fondo claro premium 10",
    "categoryId": "fondos_claros",
    "type": "image",
    "assetPath": "patrones/fondos_claros/fondos_claros_10.jpg",
    "sourceUrl": "patrones/fondos_claros/fondos_claros_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 127061,
    "sha256": "739B280B62EBCE2DBC2D79B1ACF65F33BE5C0DA5137AC9D2696BE6A382E30F76"
  },
  {
    "id": "texturas_gastronomicas_01",
    "name": "Textura gastronómica 01",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_01.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 261668,
    "sha256": "AC3E7D38FF8E4A1E58C09B01363EBCA9F1D19A3FC56E5CB05BDE794DA7870774"
  },
  {
    "id": "texturas_gastronomicas_02",
    "name": "Textura gastronómica 02",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_02.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 361206,
    "sha256": "A9124B71524CED5E653EB966B626463C392918244EDF93B7AC10DFF1EC5532CE"
  },
  {
    "id": "texturas_gastronomicas_03",
    "name": "Textura gastronómica 03",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_03.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 113350,
    "sha256": "AC1CC52E2F897ECFA7E5DEE123DA2C40A4198D1AB9A26CF4916964A9BCF5839A"
  },
  {
    "id": "texturas_gastronomicas_04",
    "name": "Textura gastronómica 04",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_04.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 229918,
    "sha256": "4DC5138D5D7C0E2D66E7504E9FE5AAA2E7F8386B6D89185CF3262C769D0E8DB9"
  },
  {
    "id": "texturas_gastronomicas_05",
    "name": "Textura gastronómica 05",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_05.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 327896,
    "sha256": "0E6A07C0C1226311C0E23D00E11D6E1F99CE4DD4731CE9B170ADAF470D0F4488"
  },
  {
    "id": "texturas_gastronomicas_06",
    "name": "Textura gastronómica 06",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_06.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 360035,
    "sha256": "FCAD3FFEFB420953A8122DF3D68C9937DC73126241F6D8E6BF05264F1A847FC1"
  },
  {
    "id": "texturas_gastronomicas_07",
    "name": "Textura gastronómica 07",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_07.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 490104,
    "sha256": "04A7E99ABF2386DE3B760EFE4AC1ADA04E325433DF86B69C08EDA73C6A93BFF7"
  },
  {
    "id": "texturas_gastronomicas_08",
    "name": "Textura gastronómica 08",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_08.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 297254,
    "sha256": "87C99D501B12503F5C156D92B1E6073A0EFAEE871B4C45811DB48F49AB7FFA31"
  },
  {
    "id": "texturas_gastronomicas_09",
    "name": "Textura gastronómica 09",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_09.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 294987,
    "sha256": "582E6E2A7A5C95F617E9680A14A066B2FCF206AC9609F9108D78E8DB7BDB30F1"
  },
  {
    "id": "texturas_gastronomicas_10",
    "name": "Textura gastronómica 10",
    "categoryId": "texturas_gastronomicas",
    "type": "image",
    "assetPath": "patrones/texturas_gastronomicas/texturas_gastronomicas_10.jpg",
    "sourceUrl": "patrones/texturas_gastronomicas/texturas_gastronomicas_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 161458,
    "sha256": "E58434A39A6722C36761E822863AF2272CE0ABC39F1523A408B51975C37AD869"
  },
  {
    "id": "eventos_01",
    "name": "Evento 01",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_01.jpg",
    "sourceUrl": "patrones/eventos/eventos_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 275307,
    "sha256": "5C8CB336A6D54A9660A080E9CAA00D62097360B97ABE1CC98E32152F7C4C87D3"
  },
  {
    "id": "eventos_02",
    "name": "Evento 02",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_02.jpg",
    "sourceUrl": "patrones/eventos/eventos_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 228880,
    "sha256": "DBC0AFE61FD16E80108BDE35999CBA5800A739A296C7D32835E90DF45ADD53B9"
  },
  {
    "id": "eventos_03",
    "name": "Evento 03",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_03.jpg",
    "sourceUrl": "patrones/eventos/eventos_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 218375,
    "sha256": "19F530C208DD161E9A5C2A44ED70D41751B0AB2B1A7001646DCE55EFC69E27F3"
  },
  {
    "id": "eventos_04",
    "name": "Evento 04",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_04.jpg",
    "sourceUrl": "patrones/eventos/eventos_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 311110,
    "sha256": "401BDFA198D6B3C7C7CC95BB208103ACC76D64C6E098511C61376A96BE9230DF"
  },
  {
    "id": "eventos_05",
    "name": "Evento 05",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_05.jpg",
    "sourceUrl": "patrones/eventos/eventos_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 204372,
    "sha256": "BB8B37718898F2C71148BA0145CFA9918DB780F8323CBE66ABFE52E0145C8DAA"
  },
  {
    "id": "eventos_06",
    "name": "Evento 06",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_06.jpg",
    "sourceUrl": "patrones/eventos/eventos_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 275762,
    "sha256": "C4EBD4A9E476CBA69FD3935FDF8B8D23036E11153ADF0B8E79A99F4122FC23C8"
  },
  {
    "id": "eventos_07",
    "name": "Evento 07",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_07.jpg",
    "sourceUrl": "patrones/eventos/eventos_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 241771,
    "sha256": "D7A569845BF82416A2F8EAD9B111DA6B387F30012465A3403D2E49DE476A31E8"
  },
  {
    "id": "eventos_08",
    "name": "Evento 08",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_08.jpg",
    "sourceUrl": "patrones/eventos/eventos_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 205637,
    "sha256": "DA1EE4B94B939F9D3106C323BC5C54EF394527E2DC38EEF9FF64A8C6584FC319"
  },
  {
    "id": "eventos_09",
    "name": "Evento 09",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_09.jpg",
    "sourceUrl": "patrones/eventos/eventos_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 418358,
    "sha256": "FDED942C7F298D179AEF78D6CA73A2A37D086C1FAB29E8B4BE44606953047A08"
  },
  {
    "id": "eventos_10",
    "name": "Evento 10",
    "categoryId": "eventos",
    "type": "image",
    "assetPath": "patrones/eventos/eventos_10.jpg",
    "sourceUrl": "patrones/eventos/eventos_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 260582,
    "sha256": "B955C29792443F33C1AF81D2FE1D3DC88A592380A1ACC7508A812340CA0A17DC"
  },
  {
    "id": "infantil_regalo_01",
    "name": "Infantil/regalo 01",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_01.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 284656,
    "sha256": "639BC09A70E0AD0D9EF0C04392948800509ACC4F272DB2ABB8396F07ED8036B2"
  },
  {
    "id": "infantil_regalo_02",
    "name": "Infantil/regalo 02",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_02.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 216013,
    "sha256": "030FCF1814E9C557DEA4DB0A9EF5053740500CCB65C5E46EE6477EC9681AB93C"
  },
  {
    "id": "infantil_regalo_03",
    "name": "Infantil/regalo 03",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_03.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 121662,
    "sha256": "1C0DF4D921757CDEE6FAC6F5D294BDF662D535F66537418F2ACB9B4B3CA609F8"
  },
  {
    "id": "infantil_regalo_04",
    "name": "Infantil/regalo 04",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_04.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 145242,
    "sha256": "D9D52813936D08C332FCB02B815C178EC7B0676E943081B74F9B64CA2E7CC01A"
  },
  {
    "id": "infantil_regalo_05",
    "name": "Infantil/regalo 05",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_05.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 232062,
    "sha256": "395DF6CFB4CDBFBA83C73DBE7B45EBC789AE71F20D119452FC30A41E7E78FF58"
  },
  {
    "id": "infantil_regalo_06",
    "name": "Infantil/regalo 06",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_06.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 143663,
    "sha256": "F3482A3A5CFD809DA189F5BCFEF838C09026D060BCCCDD274EF196F8FC929919"
  },
  {
    "id": "infantil_regalo_07",
    "name": "Infantil/regalo 07",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_07.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 220620,
    "sha256": "7B6392121755CD8782521698BC33CDED1F649AE5E8EA7095B3365D2C0A5FB069"
  },
  {
    "id": "infantil_regalo_08",
    "name": "Infantil/regalo 08",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_08.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 154949,
    "sha256": "DB617EC2193F57C4D88B718A08F730D1DF47200C29ED03543222EBEF83D12D4A"
  },
  {
    "id": "infantil_regalo_09",
    "name": "Infantil/regalo 09",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_09.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 217909,
    "sha256": "5BDE1C8F90F145B6C77581463E91CB43BDCE63C8D3DB24D9FA63ABDF44D04100"
  },
  {
    "id": "infantil_regalo_10",
    "name": "Infantil/regalo 10",
    "categoryId": "infantil_regalo",
    "type": "image",
    "assetPath": "patrones/infantil_regalo/infantil_regalo_10.jpg",
    "sourceUrl": "patrones/infantil_regalo/infantil_regalo_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 133365,
    "sha256": "3B0532B8005334BCFDE0D863A64362EA00FC7E5850C747C88A0212EE468F0F4E"
  },
  {
    "id": "premium_sobrio_01",
    "name": "Premium sobrio 01",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_01.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 283988,
    "sha256": "31D88922A0D4A40724CB9DD2B214400B93E9E1C47AC9200286101634732A4D2F"
  },
  {
    "id": "premium_sobrio_02",
    "name": "Premium sobrio 02",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_02.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 317925,
    "sha256": "92146B6BAAAB1F8C14865DDED9C8EB83415D2F32F20D5A843A89F885AE8C4346"
  },
  {
    "id": "premium_sobrio_03",
    "name": "Premium sobrio 03",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_03.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 302802,
    "sha256": "83392298440AF0F6A7EE38C225A6180DE7E838158B4D52848422528C250CB90A"
  },
  {
    "id": "premium_sobrio_04",
    "name": "Premium sobrio 04",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_04.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 330160,
    "sha256": "D7F7B71F3E3348B38436071E45D51C7F1BB4D8727597BF798DEC773D4A5A4904"
  },
  {
    "id": "premium_sobrio_05",
    "name": "Premium sobrio 05",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_05.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 256566,
    "sha256": "6C0F692D58E2C659C17611AFA56D7728C2F8815A0DA0B1C5D2D0826309570694"
  },
  {
    "id": "premium_sobrio_06",
    "name": "Premium sobrio 06",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_06.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 367866,
    "sha256": "9EB3861FEB9FA0672AB5DE9A591F980875ED92887881A5C33CA2D6113C15A029"
  },
  {
    "id": "premium_sobrio_07",
    "name": "Premium sobrio 07",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_07.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 174385,
    "sha256": "18968FBE2D66434D01F007A28AA713CC757007AB1F306C9AA4F7C9342C7F3940"
  },
  {
    "id": "premium_sobrio_08",
    "name": "Premium sobrio 08",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_08.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 200652,
    "sha256": "2B0E25FCC17579D589D840A1000E2A4EEE8891682AF7C70D78C5BB013BDD237E"
  },
  {
    "id": "premium_sobrio_09",
    "name": "Premium sobrio 09",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_09.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 174412,
    "sha256": "76CE9A840701FF6AD9E2F716B4990E00C252D2CD498C45AB69540C32F211C767"
  },
  {
    "id": "premium_sobrio_10",
    "name": "Premium sobrio 10",
    "categoryId": "premium_sobrio",
    "type": "image",
    "assetPath": "patrones/premium_sobrio/premium_sobrio_10.jpg",
    "sourceUrl": "patrones/premium_sobrio/premium_sobrio_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 236046,
    "sha256": "FBB0493C5A9615302F4B36BE1482210EECB14A55DA35E1D2CFF20264191B74FA"
  },
  {
    "id": "ladrillos_01",
    "name": "Ladrillo 01",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_01.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_01.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 722396,
    "sha256": "E9137E1A1437318CC54CA4B6BEDA7CA32AC36460D472F9D5317CEA2B27A4FB1D"
  },
  {
    "id": "ladrillos_02",
    "name": "Ladrillo 02",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_02.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_02.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 336064,
    "sha256": "684D9897BC2D149B100C1DC30824A7789F7F5300CC2F709EA4F9B732FCC8E75D"
  },
  {
    "id": "ladrillos_03",
    "name": "Ladrillo 03",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_03.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_03.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 410844,
    "sha256": "BDA7E181129282425557CD1BA367FAE73E92C697869B394FB0975571EBE443B4"
  },
  {
    "id": "ladrillos_04",
    "name": "Ladrillo 04",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_04.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_04.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 508626,
    "sha256": "DC012134727C8D42FB07EFBC3498A121BC81224F9E90E24ADB39CFF9A1F5173A"
  },
  {
    "id": "ladrillos_05",
    "name": "Ladrillo 05",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_05.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_05.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 649308,
    "sha256": "F83A550DDB2B4686C06D1F9F310ABE324BA3A607051D7F0783C4AA350B4100D3"
  },
  {
    "id": "ladrillos_06",
    "name": "Ladrillo 06",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_06.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_06.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 500793,
    "sha256": "9967C918522E2C3B15134EFC089D3C8F512B9A9C16B410645CD86DCB03E0F792"
  },
  {
    "id": "ladrillos_07",
    "name": "Ladrillo 07",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_07.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_07.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 609863,
    "sha256": "061CB01372A2DD659B06294EADCC7DC26F67D8821F3D7115198944EFABF74C1C"
  },
  {
    "id": "ladrillos_08",
    "name": "Ladrillo 08",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_08.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_08.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 432377,
    "sha256": "F40DE0F2DDE958FE4DD022A92EFBFCFBC70F13C911F4C5C41DBA0440BAE219A7"
  },
  {
    "id": "ladrillos_09",
    "name": "Ladrillo 09",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_09.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_09.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 662316,
    "sha256": "258B8C129E1950A3EE990CC6480B54AB439385B2A21CA2577A8203D0F6C6BAA4"
  },
  {
    "id": "ladrillos_10",
    "name": "Ladrillo 10",
    "categoryId": "ladrillos",
    "type": "image",
    "assetPath": "patrones/ladrillos/ladrillos_10.jpg",
    "sourceUrl": "patrones/ladrillos/ladrillos_10.jpg?v=4.6-ladrillos-oficial",
    "mimeType": "image/jpeg",
    "sizeBytes": 375495,
    "sha256": "D5943B1EC07F96488584A26F39FC1F8FAAC869C2BA7EBC22B64A40CC71DFF7AD"
  }
] as const satisfies readonly CatalogPattern[];

export interface FontFamilyOption {
  readonly family: string;
  readonly previewLabel: string;
}

export const FONT_FAMILIES = [
  {
    "family": "Montserrat",
    "previewLabel": "Moderna"
  },
  {
    "family": "Poppins",
    "previewLabel": "Redondeada"
  },
  {
    "family": "Raleway",
    "previewLabel": "Elegante"
  },
  {
    "family": "Rubik",
    "previewLabel": "Suave"
  },
  {
    "family": "Ubuntu",
    "previewLabel": "Simple"
  },
  {
    "family": "Playfair Display",
    "previewLabel": "Premium"
  },
  {
    "family": "Cormorant Garamond",
    "previewLabel": "Lujo"
  },
  {
    "family": "Lora",
    "previewLabel": "Editorial"
  },
  {
    "family": "Merriweather",
    "previewLabel": "Fuerte"
  },
  {
    "family": "Libre Baskerville",
    "previewLabel": "Clásica"
  },
  {
    "family": "Cinzel",
    "previewLabel": "Mayúscula"
  },
  {
    "family": "Roboto Slab",
    "previewLabel": "Slab"
  },
  {
    "family": "Oswald",
    "previewLabel": "Comercial"
  },
  {
    "family": "Bebas Neue",
    "previewLabel": "Impacto"
  },
  {
    "family": "Anton",
    "previewLabel": "Extra fuerte"
  },
  {
    "family": "Caveat",
    "previewLabel": "Artesanal"
  },
  {
    "family": "Dancing Script",
    "previewLabel": "Manuscrita"
  },
  {
    "family": "Pacifico",
    "previewLabel": "Marca"
  },
  {
    "family": "Great Vibes",
    "previewLabel": "Firma"
  },
  {
    "family": "Lobster",
    "previewLabel": "Retro"
  }
] as const satisfies readonly FontFamilyOption[];
